var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadlistFileIconVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 14.75V29C29 30.6569 27.6569 32 26 32V30.5C26.8284 30.5 27.5 29.8284 27.5 29V14.75H24.5C23.2574 14.75 22.25 13.7426 22.25 12.5V9.5H14C13.1716 9.5 12.5 10.1716 12.5 11V24.5H11V11C11 9.34314 12.3431 8 14 8H22.25L29 14.75ZM9.05908 31.7735V27.7833H9.11621L10.5444 31.0221H11.3179L12.7373 27.7833H12.7944V31.7735H13.8667V25.775H12.667L10.9575 29.6686H10.918L9.2085 25.775H8V31.7735H9.05908ZM16.9766 25.775H14.5772V31.7735H15.7637V29.7608H16.9678C17.3985 29.7608 17.7647 29.6744 18.0665 29.5016C18.3712 29.3258 18.6026 29.0885 18.7608 28.7897C18.9219 28.4879 19.0025 28.1495 19.0025 27.7745C19.0025 27.3995 18.9234 27.0611 18.7652 26.7594C18.607 26.4576 18.377 26.2189 18.0753 26.0431C17.7764 25.8644 17.4102 25.775 16.9766 25.775ZM17.794 27.7745C17.794 27.9972 17.7515 28.1876 17.6666 28.3458C17.5845 28.5011 17.4659 28.6212 17.3106 28.7062C17.1553 28.7882 16.9678 28.8292 16.7481 28.8292H15.7593V26.7198H16.7481C17.0762 26.7198 17.3326 26.8107 17.5171 26.9923C17.7017 27.1739 17.794 27.4347 17.794 27.7745ZM20.0514 27.7262C20.4498 27.0758 20.8453 26.4254 21.2379 25.775H22.9474V29.7037H23.6813V30.6617H22.9474V31.7735H21.8356V30.6617H18.9308V29.6905C19.2823 29.0314 19.6559 28.3766 20.0514 27.7262ZM20.0074 29.673V29.7037H21.8356V26.6715H21.774C21.4723 27.149 21.1691 27.6412 20.8644 28.1481C20.5626 28.6549 20.277 29.1632 20.0074 29.673Z",
    fill: "#868889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadlistFileIconVideo);
export default __webpack_public_path__ + "static/media/uploadlist-file-icon-video.8e3b96f61792d193828958aacf7a3677.svg";
export { ForwardRef as ReactComponent };